export enum SanctionSearchStatusTypes {
  NotStarted = 1,
  Completed = 2,
  Error = 3,
}

export enum SanctionMatchResultLevelTypes {
  NoResults = 1,
  PotentialMatch = 2,
  ConfirmedMatch = 3,
}

export interface SanctionsMatchReadDTO {
  id: string;
  screenedName: string;
  searchStatus: SanctionSearchStatusTypes;
  searchErrorReason?: string;
  matchResult: SanctionMatchResultLevelTypes;

  // OpenSanctionsMatch properties
  topOpenSanctionsMatch_EntityId?: string;
  topOpenSanctionsMatch_EntitySchema?: string;
  topOpenSanctionsMatch_EntityCaption?: string;
  topOpenSanctionsMatch_Score?: number;
  topOpenSanctionsMatch_Match?: boolean;
  topOpenSanctionsMatch_Sources_AsList: string[];
}
